import { useContext } from "react"
import { ThemeContext } from "../../context/themeContext"
import styles from "./navbarComponent.module.css"
const NavbarComponent = () => {
  const { actualTheme, setLgTheme } = useContext(ThemeContext);
  const handleThemeChange = () => {
    setLgTheme((prev: boolean) => !prev)
  }
  return (
    <nav style={{ backgroundColor: actualTheme.NavBackgroundColor }} className={`${styles.mainContainer}`}>
      <h1>Comments APP</h1>
        <label className={`${styles.switch}`}>
          <input onClick={()=>handleThemeChange()} type="checkbox" />
          <span className={`${styles.slider}`}></span>
        </label>
    </nav>
  )
}

export default NavbarComponent